<template>
  <div class="trEdit linear-main3">
    <ld-header
      class="font-lg"
      transparent
      white
      :z-index="0"
    >
      {{ $t('A126','订单填写') }}
      <router-link
        class="white"
        to="/tr/OrderService"
        slot="right"
      >
        订购须知
      </router-link>
    </ld-header>

    <mescroll-vue
      ref="mescroll"
      :down="down"
    >
      <div class="train-booking pad8">
        <!-- 经停信息 -->
        <stop-station :detail="trSearchInfo.TrainDetail" />

        <!-- 12306 登录栏 -->
        <template v-if="trSearchInfo.TravelVerificateType === TravelVerificateType[12306]">
          <van-cell
            class="train-login-cell round-sm"
            center
            is-link
            @click="$refs['the12306'].open()"
          >
            <template #title>
              <span v-if="trSearchInfo['12306Info'].trainAccount">
                已登录<br>{{ trSearchInfo['12306Info'].trainAccount }}
              </span>
              <span v-else>
                登录12306
              </span>
            </template>
            <ld-icon
              slot="icon"
              class="main-color"
              size="38"
              type="iconicon-test"
              style="margin-right: 10px;"
            />
            <span
              v-if="!trSearchInfo['12306Info'].trainAccount"
              slot="label"
            >
              铁路局规定购票需实名制
            </span>
            <span
              v-if="trSearchInfo['12306Info'].trainAccount"
              class="gray"
            >
              切换12306账号
            </span>
          </van-cell>

          <login12306
            ref="the12306"
            element=".trEdit"
          />
        </template>

        <!-- 12306常旅客 -->
        <traver12306
          v-if="trSearchInfo.TravelVerificateType === TravelVerificateType[12306]"
          class="round-sm mt5"
          :traveler-list="travelerList"
          :person-list="trSearchInfo.Ccsqd.personList"
          element=".trEdit"
          @match-clzc="matchClzc"
        >
          <span slot="title">
            乘车人
            <van-icon
              class="main-color vertical-middle"
              name="question-o"
              @click="ruleShow = true"
            />
          </span>
        </traver12306>

        <!-- 出行人 -->
        <traver
          v-else
          class="round-sm mt5"
          :traveler-list="travelerList"
          :person-list="trSearchInfo.Ccsqd.personList"
          element=".trEdit"
          @match-clzc="matchClzc"
        >
          <span slot="title">
            乘车人
            <van-icon
              class="main-color vertical-middle"
              name="question-o"
              @click="ruleShow = true"
            />
          </span>
        </traver>


        <!-- 选择座位
        v-if="trSearchInfo.TravelVerificateType === TravelVerificateType[12306] || trSearchInfo.TravelVerificateType === TravelVerificateType.tgWy"
        商旅票时才展示此选座
        -->
        <template v-if="!isNoSeatOrder && chooseSeatTypePic(trSearchInfo.SeatDetail.seatType)">
          <check-seat
            :value.sync="chooseSeats"
            :max="travelerList.length"
            :train-type="trSearchInfo.TrainDetail.trainType"
            :seat-type="trSearchInfo.SeatDetail.seatType"
            class="round-sm mt5"
          />
        </template>


        <check-seat-offline
          v-if="!isNoSeatOrder &&trSearchInfo.TravelVerificateType !== TravelVerificateType.slzx && !chooseSeatTypePic(trSearchInfo.SeatDetail.seatType)"
          :value.sync="chooseSeats"
          :max="travelerList.length"
          :train-type="trSearchInfo.TrainDetail.trainType"
          :seat-type="trSearchInfo.SeatDetail.seatType"
          class="round-sm mt5"
        />


        <van-cell
          v-if="!isNoSeatOrder && trSearchInfo.TravelVerificateType !== TravelVerificateType.slzx"
          class="accept-outseat round-sm mt5"
          :title="$t('I038','接受无座')"
          center
        >
          <van-switch
            slot="right-icon"
            v-model="acceptNoSeat"
            size="24px"
          />
        </van-cell>
        <!--        <van-cell-->
        <!--          class="accept-outseat round-sm mt5"-->
        <!--          :title="$t('I041','接受部分出票')"-->
        <!--          center-->
        <!--        >-->
        <!--          <van-switch-->
        <!--            slot="right-icon"-->
        <!--            v-model="acceptNoTotal"-->
        <!--            size="24px"-->
        <!--          />-->
        <!--        </van-cell>-->
        <van-cell
          v-if="!isNoSeatOrder && trSearchInfo.TravelVerificateType !== TravelVerificateType.slzx"
          class="accept-outseat round-sm mt5"
          :title="$t('I042','接受其他座位')"
          center
        >
          <van-switch
            slot="right-icon"
            v-model="acceptOtherSeat"
            size="24px"
          />
        </van-cell>




        <div class="round-sm mt5">
          <!-- 保险 -->
          <insurance
            ref="insurance"
            cplx="10904"
            :check-bx-list.sync="CheckBxList"
            :cxrlength="travelerList.length"
            element=".trEdit"
          />

          <!-- 服务费 -->
          <van-cell
            :title="$t('E001','服务费')"
            center
          >
            &yen; <span class="money-color">{{ trSearchInfo.sellServiceCharge }}</span>*{{ travelerList.length }}人
          </van-cell>
        </div>

        <!-- 差旅信息 -->
        <travel-info
          class="round-sm mt5"
          v-if="tripType == 1"
          ref="travelinfo"
          cplx="10904"
          element=".trEdit"
        />

        <!-- 联系信息 -->
        <div class="round-sm mt5">
          <van-field
            :label="$t('D022','联系信息')"
            is-link
            :readonly="true"
            @click="$refs['linker'].toggle()"
          >
            <div slot="input" >
              {{ linker.linkMan }} ({{ linker.linkTel }})
              <div
                class="font12 gray"
                v-if="linker.linkEmail == '' ? false : true"
              >
                {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
              </div>
            </div>
          </van-field>
        </div>

        <div class="mt5 font12 gray">
          儿童票暂显示成人价格，实际以出票为准，如有差价则1-3个工作日原路退回。
        </div>
      </div>
    </mescroll-vue>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          span="12"
          :offset="1"
        >
          <span class="font10 red">&yen;</span>
          <span
            class="font24 red"
            v-if="priceList && priceList[0]"
          >{{ priceList[0].price }}</span>
          <span class="font10 gray">{{ $t('E017','共') }}{{ travelerList.length }}人</span>

          {{ $t('E006','明细') }}
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          :offset="2"
          span="8"
        >
          <ld-button
            :loading="false"
            size="md"
            main
            @click.stop="accountValid('')"
          >
            {{ $t('F560','提交订单') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 预订规则 -->
    <Rule :visibility.sync="ruleShow" />

    <!-- 编辑联系人 -->
    <ld-edit-linker
      ref="linker"
      :data="linker"
    />

    <violate-list
      cplx="10904"
      :violate="clzcStr"
      ref="violateList"
      @selected="book"
    />

    <!--12306常旅客脱敏-->
    <van-popup
      v-model="showComplete12306"
      closeable
      round
      :style="{ height: '300px', width: '90%' }"
    >
      <div class="comp-title">
        补全乘客信息
      </div>
      <div class="comp-div">
        <div class="comp-left">
          {{ completeInfo.name }}
        </div>
      </div>
      <div class="comp-div">
        <div class="comp-left">
          证件类型:
        </div>
        <div class="comp-right">
          {{ completeInfo.identyType | getCardType }}
        </div>
      </div>
      <div class="comp-div">
        <div class="comp-left">
          证件号码:
        </div>
        <div class="comp-right-cardno">
          <div
            class="right-flex"
            v-if="completeInfo.cardNoFlag"
          >
            <template v-if="completeInfo.identyType == '1'">
              <div>{{ completeInfo.prefixCardNo }}</div>
              <van-field
                v-model="completeInfo.middleCardNo"
                placeholder=""
                maxlength="11"
              />
              <div>{{ completeInfo.suffixCardNo }}</div>
            </template>
            <template v-else>
              <van-field
                v-model="completeInfo.middleCardNo"
                placeholder=""
                class="other-card-type"
              />
            </template>
          </div>
          <div
            class="right-flex"
            v-else
          >
            {{ completeInfo.identy }}
          </div>
        </div>
      </div>
      <div class="comp-div">
        <div class="comp-left">
          手机号码:
        </div>
        <div class="comp-right-phone">
          <div
            class="right-flex"
            v-if="completeInfo.phoneFlag"
          >
            <div>{{ completeInfo.prefixPhone }}</div>
            <van-field
              v-model="completeInfo.middlePhone"
              placeholder=""
              maxlength="4"
            />
            <div>{{ completeInfo.suffixPhone }}</div>
          </div>
          <div
            class="right-flex"
            v-else
          >
            {{ completeInfo.phoneNumber }}
          </div>
        </div>
      </div>
      <div
        class="comp-div"
        style="padding-top: 30px"
      >
        <ld-button
          :loading="false"
          size="md"
          main
          @click.stop="checkAndAccountValid()"
        >
          {{ $t('B006','确定') }}
        </ld-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Cell, Field, Popup, Switch} from 'vant'
import {mapGetters} from 'vuex'

import ldButton from 'Common/ldButton'
import StopStation from '../StopStation'
import CheckSeat from './CheckSeat'
import CheckSeatOffline from './CheckSeatOffline'
import login12306 from './The12306'
import Rule from './TrRule'
import travelInfo from 'Components/travelInfo'
import insurance from 'Components/insurance'
import traver from 'Components/tr/traver'
import traver12306 from 'Components/tr/12306traver'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldEditLinker from 'Components/ldEditLinker'
import violateList from 'Components/violateList'

import {getSysType} from 'CommonUtils/plus.js'
import {formatDate} from 'Utils/dateUtil'
import {ifStrBlank} from 'Utils/string'

import TrainOrder from 'Domain/entities/train-order'
import TrainBookInteractor, {TravelVerificateType} from 'Domain/use-cases/train-book-interactor'
import {getIDcardInfo} from '@/business/utils/publicFun'
import {TRAIN_NEW_TO_OLD} from 'Utils/tools'

export default {
  name: 'TrEdit',
  components: {
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Field.name]: Field,
    [Popup.name]: Popup,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    login12306,
    ldButton,
    ldTabbar,
    travelInfo,
    insurance, violateList,
    ldEditLinker, traver, traver12306, StopStation, CheckSeat, Rule, CheckSeatOffline
  },
  data() {
    return {
      yc:false,
      down:{ use: false },
      order: new TrainOrder(),
      TravelVerificateType,
      acceptNoSeat: false, // 是否接受无座
      acceptNoTotal: false, //接受部分出票
      acceptOtherSeat: false, //接受其他坐席
      linker: {},
      chooseSeats: '',
      travelInfo: {},
      CheckBxList: [],
      ruleShow: false,
      wb: 0,
      clzcStr: '',
      showComplete12306: false,
      completeInfo: {},
      isNoSeat:false,
      isOrdered:0
    }
  },
  update(){
  },
  created() {
    this.linker = {
      linkMan: this.userInfo.empInfo.empName,
      linkTel: this.userInfo.empInfo.phoneNumber || '',
      linkEmail: this.userInfo.empInfo.email || ''
    }
    this.$store.commit('SET_SERVICE', { cplx: $dict.PRO_TYPE.tr })
    this.getConfig()
    if(this.linker.linkEmail == '') {
      this.yc = false
    }else{
      console.log(this.linker.linkEmail,'----')
      this.yc = true
    }
  },
  mounted() {

    /*
    *出差申请单信息回显
    * this.tkSearchInfo.Ccsqd 存储出差单详情信息
    * this.$refs.travelinfo.getInfo方法 出差申单号回显到页面
    */
    setTimeout(() => {
      if (this.tripType == 1) {
        this.$refs.travelinfo.getInfo({...this.trSearchInfo.Ccsqd, ...this.trSearchInfo.violate})
      }
    })

  },
  methods: {
    yc(){
      console.log(this.$refs.travelinfo)
    },
    chooseSeatTypePic(seatType){
      const SEATTYPES = ['9','M','O']
      if (SEATTYPES.includes(seatType)){
        return true
      }else {
        return false
      }
    },
    //获取火车票产品配置
    async getConfig () {
      await this.$api['common/queryVipParameter']({
        paramNo:'11603003'
      }).then(res => {
        this.acceptOtherSeat = res.data.value1 === '1'
      })
      //如果是无座订单 接受无座
      if (this.isNoSeatOrder){
        this.acceptNoSeat = true
      }
    },
    getXpPrice (seatType) {
      if (seatType == 3) {
        return this.trSearchInfo.TrainDetail.ywxPrice
      } else if (seatType == 4) {
        return this.trSearchInfo.TrainDetail.rwxPrice
      } else if (seatType == 6) {
        return this.trSearchInfo.TrainDetail.gjrwxPrice
      } else if (seatType == 'I') {
        return this.trSearchInfo.TrainDetail.ydwxPrice
      } else if (seatType == 'J') {
        return this.trSearchInfo.TrainDetail.edwxPrice
      } else if (seatType == 'F') {
        return this.trSearchInfo.TrainDetail.srrbxPrice
      }

      return false
    },
    /**
     * 修改乘车人，重新匹配差标
     */
    async matchClzc () {
      const { minzjName, minzj } = this.serviceCtrl.getClbzMinZj(this.travelerList)
      this.trSearchInfo.minRank = minzj

      const { wb, clzcStr } = await TrainBookInteractor.getTravelPolicyDetail(
        this.trSearchInfo.minRank,
        this.trSearchInfo.TrainDetail.trainCode,
        this.trSearchInfo.SeatDetail.seatType
      )

      this.clzcStr = clzcStr
      this.wb = wb
    },
    accountValid() {
      // 12306账号必填
      if (this.trSearchInfo.TravelVerificateType === TravelVerificateType[12306]) {
        if (!this.trSearchInfo['12306Info'].trainAccount || !this.trSearchInfo['12306Info'].password) {
          this.$refs['the12306'].open(this.valid)
        } else {
          var checkFlag = false
          for (var i = 0; i < this.travelerList.length; i++) {
            var tl = this.travelerList[i]
            if (tl.identy.indexOf('*') > -1 || tl.phoneNumber.indexOf('*') > -1) {
              this.completeInfo = this.handleCompleteInfo(JSON.parse(JSON.stringify(tl)))
              checkFlag = true
              break
            }
          }
          if (checkFlag) {
            this.showComplete12306 = true
            return
          }
          this.showComplete12306 = false
          this.valid()
        }
      } else {
        this.valid()
      }
    },
    async checkAndAccountValid() {
      if (this.completeInfo.cardNoFlag) {
        if (ifStrBlank(this.completeInfo.middleCardNo)) {
          this.$validErrorTips('请补充证件号码')
          return
        }
      }
      if (this.completeInfo.phoneFlag) {
        if (ifStrBlank(this.completeInfo.middlePhone)) {
          this.$validErrorTips('请补充手机号码')
          return
        }
      }

      var fullCardNo = this.completeInfo.identy
      if (this.completeInfo.cardNoFlag) {
        fullCardNo = this.completeInfo.prefixCardNo + this.completeInfo.middleCardNo + this.completeInfo.suffixCardNo
      }
      var fullPhone = this.completeInfo.phone
      if (this.completeInfo.phoneFlag) {
        fullPhone = this.completeInfo.prefixPhone + this.completeInfo.middlePhone + this.completeInfo.suffixPhone
      }

      if (this.completeInfo.identyType == '1') {
        let idcardInfo = getIDcardInfo(fullCardNo)
        this.completeInfo.sex = idcardInfo.sex == '1' ? '0' : '1'
        this.completeInfo.born = idcardInfo.born
      }

      let params = {
        trainAccount: this.trSearchInfo['12306Info'].trainAccount,
        pass: this.trSearchInfo['12306Info'].password,
        contacts: {
          id: this.completeInfo.id,
          name: this.completeInfo.name,
          sex: this.completeInfo.sex,
          birthday: this.completeInfo.born,
          country: this.completeInfo.nation,
          getValidDateEnd: this.completeInfo.expiryDate,
          identyType: this.completeInfo.identyType,
          identy: this.completeInfo.identyType == '1' ? fullCardNo : this.completeInfo.middleCardNo,
          personType: this.completeInfo.personType,
          phone: fullPhone,
          email: this.completeInfo.email,
          desensitization: 0
        }
      }

      try {
        const {data = []} = await this.$api['trQuery/saveClk'](params)
        console.log(data, 'saveClk resp')
        for (var i = 0; i < this.travelerList.length; i++) {
          if (this.travelerList[i].id == this.completeInfo.id) {
            this.travelerList[i].identy = fullCardNo
            this.travelerList[i].phone = fullPhone
            this.travelerList[i].phoneNumber = fullPhone
          }
        }
        this.getClkList()
        this.accountValid()
      } catch (error) {
        throw error
      }
    },
    handleCompleteInfo(data) {
      if (data.identy.indexOf('*') > -1) {
        data.cardNoFlag = true
        if (data.identyType == '1') { //身份证
          data.prefixCardNo = data.identy.substring(0, 4)
          data.suffixCardNo = data.identy.substring(data.identy.length - 3)
        }
      }

      if (data.phoneNumber.indexOf('*') > -1) {
        data.phoneFlag = true
        data.prefixPhone = data.phoneNumber.substring(0, 3)
        data.suffixPhone = data.phoneNumber.substring(data.phoneNumber.length - 4)
      }
      return data
    },
    async valid() {
      switch(this.wb) {
        case 1:
          if (this.$refs['violateList'].isShow === false) {
            this.$refs['violateList'].toggle()
            return
          }
          break
        case 2:
          this.$dialog({message: '您选择的出行人违背差旅标准，不允许预订，请重新选择。'})
          break
      }

      /**
       * 差旅信息验证
       */
      if (this.tripType == 1) {
        let bl = this.$refs.travelinfo.result()
        if (bl === false) {
          return false
        } else {
          this.travelInfo = bl
        }
      }

      let passengerList = []
      try {

        if (this.trSearchInfo.TravelVerificateType === TravelVerificateType[12306]) {
          this.travelerList.forEach((travel, i) => {
            if (travel.isNotAccount) {
              throw `乘客${travel.name}不存在12306常旅客中，请更换12306账号或添加常旅客`
            }

            if (!travel.passed) {
              throw `乘客${travel.name}的联系方式尚未通过核验，请先完成信息核验`
            }

            // 儿童票向上找对应成人票的证件信息
            // if (travel.psgType === '2') {
            // 	travel = {
            // 		...this.travelerList[i - 1],
            // 		ticketType: '2',
            // 		passengerType: '2',
            // 	}
            // }
            console.log("trains book passengerType val {}",travel.psgType)
            if(travel.psgType){
              //这样判断避免 有婴儿类型火车票无法下单问题,
              if (travel.psgType === '1' || travel.psgType === 1){
                travel.psgType = 1;
              }else {
                travel.psgType = 2;
              }
            }


            passengerList.push({
              born: travel.born,
              expiryDate: travel.expiryDate,
              empId: travel.empId,
              idType: travel.identyType,
              idCode: travel.identy,
              insureAmount: this.insureAmount,
              nation: travel.nation,
              phoneNumber: travel.phoneNumber,
              passengerName: travel.name,
              passengerType: travel.psgType || '1',
              sex: travel.sex,
              ticketType: travel.psgType || '1',
              email: travel.email
            })
          })
        } else {
          this.travelerList.forEach((travel, i) => {
            // 儿童票向上找对应成人票的证件信息
            // if (travel.psgType === '2') {
            // 	travel = {
            // 		...this.travelerList[i - 1],
            // 		ticketType: '2',
            // 		passengerType: '2',
            // 	}
            // }

            console.log("trains book passengerType val {}",travel.psgType)
            if(travel.psgType){
              //这样判断避免 有婴儿类型火车票无法下单问题,
              if (travel.psgType === '1' || travel.psgType === 1){
                travel.psgType = 1;
              }else {
                travel.psgType = 2;
              }
            }


            passengerList.push({
              born: travel.born,
              expiryDate: travel.expiryDate,
              empId: this.$options.filters.getId(travel),
              fsEmpId: travel.fsEmpId,
              idType: this.$options.filters.getIdType(travel),
              idCode: this.$options.filters.getIdNumber(travel),
              insureAmount: this.insureAmount,
              nation: travel.nation,
              phoneNumber: travel.phoneNumber,
              passengerName: this.$options.filters.getName(travel),
              passengerType: travel.psgType || '1',
              sex: travel.sex,
              ticketType: travel.psgType || '1',
              email: this.$options.filters.getEmail(travel)
            })
          })
        }
      } catch (error) {
        this.$dialog({title: '提示', message: (error && error.tips ? error.tips : (error || '核验接口报错'))})
        return false
      }

      if(this.linker.linkMan == undefined || this.linker.linkMan == ''){
        console.log(this.linker.linkMan,'***')
        if(this.linker.linkMan == ''){
          this.yc = true
        }else{
          this.yc = false
        }
        this.$dialog({title: '提示', message: '请完善联系人信息'})
        return false
      }

      Object.assign(this.order, {
        'chooseSeats': this.chooseSeats,
        'acceptNoSeat': this.acceptNoSeat,
        'acceptNoTotal': this.acceptNoTotal,
        'acceptOtherSeat': this.acceptOtherSeat,

        'ccsqdId': this.travelInfo.ccsqdId,
        'ccsqdNo': this.travelInfo.ccsqdNo,
        'ccsqdRemark': this.travelInfo.ccsy||this.travelInfo.ccsqdRemark||'',
        'subjectCode': this.travelInfo.subjectCode,

        'costCenterCode': this.travelInfo.costCenterCode,
        'costCenterId': this.travelInfo.costCenterId,
        'costCenterName': this.travelInfo.costCenterName,

        'projectCode': this.travelInfo.projectCode,
        'projectId': this.travelInfo.projectId,
        'projectName': this.travelInfo.projectName,

        'reasonCode': this.trSearchInfo.violate.reasonCode,
        'reasonDesc': this.trSearchInfo.violate.reasonDesc,

        'violateitem': this.trSearchInfo.violate.violateItem ? this.trSearchInfo.violate.violateItem : this.trSearchInfo.SeatDetail.wb,
        'violateitemCode': this.trSearchInfo.violate.reasonCode ? this.trSearchInfo.violateCode : '',
        'ifViolate': this.trSearchInfo.violate.reasonCode ? '1' : '0',

        'fromDate': this.trSearchInfo.TrainDetail.byTrainDate,
        'fromStationCode': this.trSearchInfo.TrainDetail.fromStationCode,
        'fromStationName': this.trSearchInfo.TrainDetail.fromStationName,
        'fromTime': this.trSearchInfo.TrainDetail.startTime,

        'toDate': formatDate(this.trSearchInfo.TrainDetail.byTrainDate, this.trSearchInfo.TrainDetail.arriveDays).date,
        'toStationCode': this.trSearchInfo.TrainDetail.toStationCode,
        'toStationName': this.trSearchInfo.TrainDetail.toStationName,
        'toTime': this.trSearchInfo.TrainDetail.arriveTime,

        'trainNo': this.trSearchInfo.TrainDetail.trainNo,
        'trainCode': this.trSearchInfo.TrainDetail.trainCode,
        'isByidcard': this.trSearchInfo.TrainDetail.isByidcard,

        'linkEmail': this.linker.linkEmail === '' ? '' : this.$options.filters.getEmail({ chName: '联系人', cardType: '2', email: this.linker.linkEmail }),
        'linkTel': this.linker.linkTel,
        'linkman': this.linker.linkMan,

        'ontTicketPrice': Number(this.trSearchInfo.SeatDetail.price) + this.diffPrice,
        'ticketPrice': (Number(this.trSearchInfo.SeatDetail.price) + this.diffPrice) * this.travelerList.length, // 总票价

        'orderFrom': getSysType(),
        'passengerList': passengerList, // 乘机人

        // 'routeId': this.routeId,
        'routeId': this.$route.query.routeId ? this.$route.query.routeId : this.routeId,
        'seatType': this.trSearchInfo.SeatDetail.seatType, //座位类型  9:商务座  P:特等座  M:一等座   O:二等座/无座  6:高级软卧  4:软卧  3:硬卧  2:软座  1:硬座/无座 ,
        'seatName': this.trSearchInfo.SeatDetail.seatName, //座位名称 主要是为了方便进行二等座/硬座的无座判断 2023年3月5日17:44:57
        'sellServiceCharge': this.trSearchInfo.sellServiceCharge,
        'supplierCode': this.trSearchInfo.supplierCode,
        'supplierId': this.trSearchInfo.supplierId,
        'supplierName': this.trSearchInfo.supplierName,
        'travelStandard': this.trSearchInfo.minRank,
        'tripType': this.tripType
      })

      if (this.trSearchInfo.TravelVerificateType === TravelVerificateType[12306]) {
        this.order.trainAccount = this.trSearchInfo['12306Info'].trainAccount
        this.order.password = this.trSearchInfo['12306Info'].password
        this.order.ydType = '1'
      } else if (this.trSearchInfo.TravelVerificateType === TravelVerificateType.emp) {
        this.order.ydType = '2'
      } else if (this.trSearchInfo.TravelVerificateType === TravelVerificateType.tgWy) {
        this.order.ydType = '3'
      }else if (this.trSearchInfo.TravelVerificateType === TravelVerificateType.slzx) {
        this.order.ydType = '4'
      }

      try {
        const { data = {} } = await TrainBookInteractor.validOrder(this.order)
        if (data.isNear === '1') {
          this.$dialog.confirm({
            message: data.tips,
            confirmButtonText: this.$t('B061','重新查询'),
            cancelButtonText: this.$t('B012','继续预订')
          }).then(() => {
            this.$router.push({ path: '/tr/trQuery' })
          }).catch(() => {
            this.book()
          })
        } else {
          this.book()
        }
      } catch (error) {
        // 火车票校验订单接口(重复订单、行程时间冲突订单、临近行程)
        this.$dialog({title:'提示',message: (error&&error.tips?error.tips:(error||'火车票校验订单接口报错'))})
      }
    },
    async book () {
      try {
        //是否已经提交订单
        if (this.isOrdered > 0){
          this.$dialog({title:'提示',message: '已提交订单无需重复点击'})
          return
        }
        this.isOrdered++
        const { data = {}} = await TrainBookInteractor.book(this.order, this.CheckBxList)

        let orderId = data.orderId || ''
        let orderNo = data.orderNo || ''
        let spgzId = data.spgzId || ''

        // 用户提交订单是否自动送审（1：是；0：否；）
        await this.$api['common/queryParameter']({
          'paramNos': '20023'
        }).then(res => {
          let p_20023 = false
          if (res.data && res.data.parameterResponses && res.data.parameterResponses[0] && res.data.parameterResponses[0].value1) {
            p_20023 = res.data.parameterResponses[0].value1 === '1'
          }
          if (p_20023 && spgzId) {

            // 送审
            this.$api['approval/vipBpmSendAppNew']({
              'orderType': '11009',
              'againApp': 1,
              'orderId': orderId,
              'orderNo': orderNo,
              'spgzId': spgzId,
            }).then(res => {
              this.$router.push({path: '/allOrder?findType=1'})

              // // 查询审批中订单
              // this.$api['approval/vipBpmForMyAppNew']({
              //   'approveType': 1,
              //   'count': 50,
              //   'orderNo': orderNo,
              // }).then(res => {
              //   let approvingList = res.data.list[0].vipBpmForMyAppDtoList
              //   for (let approve of approvingList) {
              //     if (approve.orderId === orderId) {
              //       // 审批订单
              //       this.$api['approval/vipBpmReceiveAppResult']({
              //         'appRemark': '',
              //         'completeState': 1,
              //         'completeWay': 2,
              //         'workItemId': approve.workItemId
              //       });
              //       break;
              //     }
              //   }
              //
              //   this.$router.push({path: '/allorder'});
              // });
            })
          } else {
            this.jump(data)
          }
        }).catch(() => {
          this.jump(data)
        })
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 下单结束 - 清除缓存 - 跳转完成页面
     */
    jump ({orderId}) {
      this.$router.push({ path: `/tr/trCmp/${orderId}` })
      this.$store.commit('tr/CLEAR_TRSEARCHINFO')
    },
    async getClkList () {
      this.$store.dispatch('tr/getAccountPsgList')
    },
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo',
      travelerList: 'tr/travelerList',
      userInfo: 'userInfo',
      tripType: 'tripType',
      serviceCtrl: 'serviceCtrl'
    }),
    // 计算保险单人金额
    insureAmount: vm => vm.CheckBxList.reduce((sum, bx) => sum + bx.saleprice, 0),
    // 计算 `底部导航` 的价格明细
    priceList () {
      let adultLength = 0,
        adultPrice = Number(this.trSearchInfo.SeatDetail.price),
        sellServiceCharge = Number(this.trSearchInfo.sellServiceCharge) || 0,
        childLength = 0,
        childPrice = adultPrice

      if(this.travelerList.length > 0) {
        this.travelerList.forEach((travel) => {
          if(this.$options.filters.getId(travel)) adultLength++
          if(travel.psgType === '2') childLength++
        })
      }

      let total = (adultPrice + this.insureAmount + sellServiceCharge + this.diffPrice) * adultLength + (childPrice + this.insureAmount + sellServiceCharge + this.diffPrice) * childLength
      let rt = [
        { name: this.$t('E002','总额'), price: total, amount: '',	unit: '' },
        { name: this.$t('C115','成人'), price: adultPrice, amount: adultLength, unit: this.$t('E113','人') }
      ]

      if (this.diffPrice) {
        rt.push({ name: '下铺差价', price: this.diffPrice, amount: adultLength, unit: this.$t('E113','人') })
      }

      if (childLength > 0) rt.push({ name: this.$t('C116','儿童'), price: childPrice, amount: childLength, unit: this.$t('E113','人') })
      if (sellServiceCharge > 0) rt.push({ name: this.$t('E001','销售服务费'), price: sellServiceCharge, amount: this.travelerList.length, unit: this.$t('E113','人')})
      if (this.CheckBxList && this.CheckBxList.length > 0) rt.push({ name: this.$t('E505','保险'), price: this.insureAmount, amount: this.travelerList.length, unit: this.$t('E113','人')})

      return rt
    },
    /**
     * singa代购现金票
     * 卧铺传下铺的价格 （下铺比中上铺贵）
     */
    diffPrice () {
      if (
        this.trSearchInfo.TravelVerificateType === TravelVerificateType.emp &&
        this.getXpPrice(this.trSearchInfo.SeatDetail.seatType)
      ) {
        return Number(this.getXpPrice(this.trSearchInfo.SeatDetail.seatType)) - Number(this.trSearchInfo.SeatDetail.price)
      } else {
        return 0
      }
    },
    /**
     * 判断是否为无座订单
     */
    isNoSeatOrder () {
      if (
        this.trSearchInfo.SeatDetail.seatName === '无座'
      ) {
        return  true
      } else {
        return  false
      }
    }
  },
  updated() {
    this.travelerList.forEach((t) => {
      var idType = TRAIN_NEW_TO_OLD()[t.cardType]
      t.cardType = (idType == undefined?t.cardType:idType.key)
      t.otherNumber = t.idNumber
      t.passport = t.idNumber
    })
  },
  filters: {
    getIdType(val) {
      if (val.cardType) return val.cardType
      if (val.idNumber) {
        return '1'
      } else if (val.cardType == 2) {
        return 'B'
      }
    },
    getCardType(val){
      switch (val) {
        case '1':
          return '身份证'
        case 'B':
          return '护照'
        case 'C':
          return '港澳居民来往内地通行证'
        case 'G':
          return '台湾居民来往大陆通行证'
        case 'H':
          return '外国人永久居留身份证'
        case '2':
          return '港澳台居民居住证'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less">
.trEdit {
  height: calc(100vh - 42px);
  padding-bottom: 60px;

  .mt5 {
    margin-top: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .train-booking {
    padding: 0 8px;
  }

  .pad16 {
    padding: 16px;
  }

  .round-sm {
    overflow: hidden;
  }

  .van-switch__node {
    z-index: 0;
  }

  .comp-title{
    text-align: center;
    margin-top: 15px;
    font-size: 16px;
  }
  .comp-div{
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 0 20px;
  }
  .comp-left{
    display: flex;
    align-items: center;
    width: 80px;
  }
  .comp-right{
    display: flex;
    align-items: center;
    flex: 1;
  }

  .right-flex{
    display: flex;
    align-items: center;
    justify-content: center
  }
  .comp-right-cardno{
    display: flex;
    align-items: center;
    flex: 1;

    .van-cell{
      padding: 0;
      padding-left: 2px;
    }
    .van-field__control{
      width: 90px;
      border-bottom: 1px solid @color-text-main;
      color: @color-text-main;
    }
    .other-card-type{
      .van-field__control{
        width: 140px;
      }
    }
  }
  .comp-right-phone{
    display: flex;
    align-items: center;
    flex: 1;

    .van-cell{
      padding: 0;
      padding-left: 2px;
    }
    .van-field__control{
      width: 34px;
      border-bottom: 1px solid @color-text-main;
      color: @color-text-main;
    }
  }
}
</style>
